/* 清水材木店 商品ページ：在庫切れの追加料金（Globo のアイアン脚など）を「在庫切れ」と出し、選べなくする。見た目は szk-oos.css
   - Globo は読み込んだときだけ在庫切れを選べなくするが、条件で項目を出し直すと選べてしまい、カートで「Some items are no longer available」になる
     （2026-10-21 本人の指摘。大型・通常サイズのアイアン脚で、脚の奥行 740mm の WHITE）
   - 追加料金の商品のバリアントを公開の /variants/○○.js で確かめ、売れないものに印（szk-oos）を付け、選べないようにする。在庫の数や設定は変えない
   - 見た目の範囲（大型だけ）とは別に、すべての商品ページで読む（szk-product-style.liquid）。Globo の追加料金がないページでは何もしない */
(() => {
  'use strict'
  const root = document.querySelector('.product--container') || document.body
  const shopBase = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/')
  const oos = new Set()
  const asked = new Set()

  function markOos() {
    for (const i of root.querySelectorAll('input[gpo-data-variant-id]')) {
      const bad = oos.has(i.getAttribute('gpo-data-variant-id'))
      const item = i.closest('.gpo-swatches')
      if (item && item.classList.contains('szk-oos') !== bad) item.classList.toggle('szk-oos', bad)
      if (!bad) continue
      if (!i.disabled) i.disabled = true
      if (i.checked) { i.checked = false; i.dispatchEvent(new Event('change', { bubbles: true })) }
      const t = item?.querySelector('.gpo-tooltip__title span, .gpo-tooltip__title')
      if (t && !t.dataset.szkOos) { t.dataset.szkOos = '1'; t.textContent = `${t.textContent.trim()}（在庫切れ）` }
    }
    for (const o of root.querySelectorAll('option[gpo-data-variant-id]')) {
      if (!oos.has(o.getAttribute('gpo-data-variant-id'))) continue
      if (!o.disabled) o.disabled = true
      if (!o.dataset.szkOos) { o.dataset.szkOos = '1'; o.textContent = `${o.textContent.trim()}（在庫切れ）` }
      if (o.selected) { const s = o.closest('select'); s.value = ''; s.dispatchEvent(new Event('change', { bubbles: true })) }
    }
  }

  async function checkStock() {
    const ids = [...new Set([...root.querySelectorAll('[gpo-data-variant-id]')].map((e) => e.getAttribute('gpo-data-variant-id')).filter(Boolean))].filter((id) => !asked.has(id))
    ids.forEach((id) => asked.add(id))
    await Promise.all(ids.map(async (id) => {
      try { const r = await fetch(`${shopBase}variants/${id}.js`, { credentials: 'same-origin' }); if (r.ok && !(await r.json()).available) oos.add(id) } catch {}
    }))
    if (oos.size) markOos()
  }

  // Globo は読み込みのあとに部品を作り、条件で出し直す（そのたびに disabled を外す）ので、変わるたびに少し待って見直す
  let timer = 0
  const later = () => { clearTimeout(timer); timer = setTimeout(checkStock, 120) }
  new MutationObserver(later).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'style'] })
  root.addEventListener('change', later)
  // 念のため：在庫切れの選択肢は押しても選ばれないようにする（吹き出しは出す）
  root.addEventListener('click', (e) => { if (e.target.closest?.('.gpo-swatches.szk-oos')) { e.preventDefault(); e.stopPropagation() } }, true)
  checkStock()
})()
